import { FC, useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Form,
  Grid,
  Input,
  Row,
  SelectForm,
  Span,
  CurrencyInput,
} from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { RolDocumentsServices } from 'services/NGT/Parameterization'
import { COLORS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import * as Yup from 'yup'

import {
  DialogContentStyled,
  DialogTitleStyled,
  RollStamp
} from './ModalRegisterRollDocs.styles'
import { useModal } from 'hooks'

interface IFormType {
  txtTipoDocumento: string
  txtDescDocumento: string
  cdTipoEfetivo: string
  cdStatusEfetivo: string
  cdCalcRisco: string
  cdPeriodicidade: string
  nuIndice: string
  rolPrincipalId: number
  tipoPendenciaId: number
}

interface IModalNovJobs {
  showModal?: boolean
  toggleModal?: () => void
  onSubmit?: (data: any) => void
}

const schema = Yup.object({
  cdCalcRisco: Yup.string().required('Campo obrigatório'),
  cdPeriodicidade: Yup.string().required('Campo obrigatório'),
  cdStatusEfetivo: Yup.string().required('Campo obrigatório'),
  cdTipoEfetivo: Yup.string().required('Campo obrigatório'),
  rolPrincipalId: Yup.string().required('Campo obrigatório'),
  tipoPendenciaId: Yup.string().required('Campo obrigatório'),
  txtDescDocumento: Yup.string().required('Campo obrigatório'),
  txtTipoDocumento: Yup.string().required('Campo obrigatório')
})

const ModalRegisterRollDocs: FC<IModalNovJobs> = ({
  showModal,
  toggleModal,
  onSubmit
}) => {
  const [pendenciasModal, setPendenciasModal] = useState<any[] | undefined>()
  const [tipoEfetivoModal, setTipoEfetivoModal] = useState<any[] | undefined>()
  const [statusModal, setStatusModal] = useState<any[] | undefined>()
  const [calcRiscoModal, setCalcRiscoModal] = useState<any[] | undefined>()
  const [periodicidadeModal, setPeriodicidadeModal] = useState<
    any[] | undefined
  >()
  const [dependenteModal, setDependenteModal] = useState<any[] | undefined>()
  const [selectDependenteModal, setSelectDependenteModal] = useState<any[]>([])
  const [rolDocumentModal, setRolDocumentModal] = useState<string | undefined>()

  const { setLoading, setMsgErro } = useLoading()

  const { showModal: showModalUseModal } = useModal()

  const defaultForm = {
    cdCalcRisco: undefined,
    cdPeriodicidade: undefined,
    cdStatusEfetivo: undefined,
    cdTipoEfetivo: undefined,
    nuIndice: undefined,
    rolPrincipalId: undefined,
    tipoPendenciaId: undefined,
    txtDescDocumento: undefined,
    txtTipoDocumento: undefined
  }

  const {
    control,
    watch,
    reset,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<IFormType>({
    defaultValues: defaultForm,
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    const getParams = () => {
      setLoading('loading')
      RolDocumentsServices()
        .getAllParametrosCDU()
        .then(({ data }) => {
          if (data.sucesso) {
            data.entity?.forEach((el) => {
              if (el.chave === 'Calculo Risco') {
                setCalcRiscoModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }

              if (el.chave === 'Pendencia') {
                setPendenciasModal(el.valores)
              }

              if (el.chave === 'Periodicidade') {
                setPeriodicidadeModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }

              if (el.chave === 'TipoEfetivo') {
                setTipoEfetivoModal(
                  el.valores.map((el) => ({
                    itens: el.itens,
                    label: el.tipoEfetivo,
                    value: el.tipoEfetivo
                  }))
                )
              }

              if (el.chave === 'Status do Efetivo') {
                setStatusModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }
              if (el.chave === 'Dependente') {
                setDependenteModal(el.valores)
              }
            })
          }
          setLoading('idle')
        })
        .catch((err) => {
          // setMsgErro(err)
          // setLoading('error')
          setLoading('idle')
          showModalUseModal({
            hideButtonCancel: true,
            message: err,
            type: 'error'
          })
        })
    }
    getParams()
  }, [])

  const watchPendencia = watch('tipoPendenciaId')
  const watchEfetivo = watch('cdTipoEfetivo')

  useEffect(() => {
    if (watchPendencia) {
      const index = pendenciasModal?.findIndex(
        (el) => el.idTipoPendencia === watchPendencia
      )
      index && setValue('txtTipoDocumento', pendenciasModal[index]?.txTipo)
      index == 0 && setValue('txtTipoDocumento', pendenciasModal[index]?.txTipo)
    }
  }, [watchPendencia])

  useEffect(() => {
    if (watchEfetivo) {
      //BUSCA QUAL ROL E O TIPO EFETIVO
      const refTipo = tipoEfetivoModal?.find((el) => el?.value === watchEfetivo)

      // BUSCA LISTA DEPENDENTES DE ACORDO COM O ROL
      if (refTipo?.itens?.length > 0) {
        const refDep = dependenteModal?.find(
          (el) => el.rol === refTipo?.itens[0]?.rol
        )
        //TROCA LISTA DO SELECT
        setSelectDependenteModal(refDep?.itens ?? [])
        //TROCA NUMERO ROL MODAL
        setRolDocumentModal(refDep?.rol ?? [])
      }
    }
  }, [watchEfetivo])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'md'}
    >
      <DialogTitleStyled>Novo Item Rol de Documentos</DialogTitleStyled>
      <DialogContentStyled>
        <Form
          onSubmit={(data) => {
            handleSubmit(onSubmit)(data).then(() => {
              resetModalState(draggableReference)
            })
          }}
        >
          <Grid
            gridCols="2fr 1fr 4fr .05fr .5fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing20} 0`}
          >
            <SelectForm
              listOptions={pendenciasModal}
              label="Pendência"
              placeholder="Selecione"
              errors={errors}
              labelMenu="txDescricao"
              valueMenu="idTipoPendencia"
              formValue="tipoPendenciaId"
              control={control}
            />
            <Input
              control={control}
              errors={errors}
              formValue="txtTipoDocumento"
              disabled
              label="Tipo"
              placeholder="Tipo"
            />
            <Input
              maxLength={1000}
              formValue="txtDescDocumento"
              label="Descrição"
              placeholder="Descrição"
              errors={errors}
              control={control}
            />
            <div />
            <RollStamp>
              <Span
                textAlign="center"
                text={`ROL ${rolDocumentModal || '0'}`}
                color={COLORS.black}
                fontSize={TYPOGRAPHY.subtitleSize20}
              />
            </RollStamp>
          </Grid>
          <Grid
            gridCols="1.2fr 1.2fr 1.2fr 1.2fr 1.2fr 1.2fr 0.8fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing5} 0 ${SPACING.spacing20} 0`}
          >
            <SelectForm
              listOptions={tipoEfetivoModal}
              label="Tipo Efetivo"
              placeholder="Selecione"
              formValue="cdTipoEfetivo"
              control={control}
              errors={errors}
            />
            <SelectForm
              listOptions={statusModal}
              label="Status do Efetivo"
              placeholder="Selecione"
              formValue="cdStatusEfetivo"
              control={control}
              errors={errors}
            />
            <SelectForm
              listOptions={calcRiscoModal}
              label="Cálculo de Risco"
              placeholder="Selecione"
              formValue="cdCalcRisco"
              control={control}
              errors={errors}
            />
            <CurrencyInput
              defaultValue=""
              formValue="nuIndice"
              label="Índice (%)"
              style="percent"
              control={control}
              errors={errors}
              maxLength={6}
            />
            <SelectForm
              control={control}
              errors={errors}
              formValue="cdPeriodicidade"
              listOptions={periodicidadeModal}
              label="Periodicidade"
              placeholder="Selecione"
            />
            <SelectForm
              listOptions={FORMAT.orderByPropValue(
                [{ dependente: 'Não', id: 'Não' }, ...selectDependenteModal],
                'dependente'
              )}
              formValue="rolPrincipalId"
              label="Dependente"
              placeholder="Qtd."
              labelMenu="dependente"
              valueMenu="id"
              control={control}
              errors={errors}
            />
          </Grid>

          <Row justifyContent="flex-end" marginTop={SPACING.spacing50}>
            <Button
              text="Limpar"
              variantButton="text"
              onClick={() =>
                reset({
                  nuIndice: '',
                  txtDescDocumento: '',
                  txtTipoDocumento: ''
                })
              }
            />
            <Button
              text="Voltar"
              variantButton="outlined"
              onClick={() => {
                toggleModal()
                resetModalState(draggableReference)
              }}
              marginLeft={SPACING.spacing15}
            />
            <Button
              text="Salvar"
              type="submit"
              marginLeft={SPACING.spacing15}
            />
          </Row>
        </Form>
      </DialogContentStyled>
    </DraggableDialog>
  )
}

export default ModalRegisterRollDocs
